module.exports = __webpack_public_path__ + "static/media/xclock.56290bfb.png";